import React from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';

import './Fade.css';

class Fade extends React.Component {
  static propTypes = {
    delay: PropTypes.number,
    children: PropTypes.node,
    modifyChild: PropTypes.bool,
    type: PropTypes.oneOf([
      'TOP',
      'RIGHT',
      'BOTTOM',
      'LEFT',
      'OPACITY'
    ])
  };

  static defaultProps = {
    delay: 10,
    type: 'OPACITY'
  };

  state = {
    className: ''
  };

  componentDidMount() {
    const { modifyChild } = this.props;
    const node = findDOMNode(this);
    if (modifyChild) {
      node.classList.add('__fade');
      node.setAttribute('data-transition-type', this.props.type);
    }

    setTimeout(() => {
      if (modifyChild) {
        node.classList.add('faded');
      } else {
        this.setState({ className: 'faded' });
      }
    }, this.props.delay);
  }

  componentWillUnmount() {
    if (this._node) {
      this._node.className = '';
    }
  }

  render() {
    const { type, modifyChild, children } = this.props;

    if (modifyChild) {
      return children;
    }

    return (
      <div
        name="Fade"
        className={this.state.className}
        ref={node => this._node = node}
        data-transition-type={type}>
        {children}
      </div>
    );
  }

}

export default Fade;
